class User {
  constructor(obj) {
    obj = obj != null ? obj : {};
    this.firstName = obj.firstName != null ? obj.firstName : "";
    this.lastName = obj.lastName != null ? obj.lastName : "";
    this.otherName = obj.otherName != null ? obj.otherName : "";
    this.gender = obj.gender != null ? obj.gender : "";
    this.birthDate = obj.birthDate != null ? obj.birthDate : "";
    this.maritalStatus = obj.maritalStatus != null ? obj.maritalStatus : "";
    this.email = obj.email != null ? obj.email : "";
    this.region = obj.region != null ? obj.region : "";
    this.nationality = obj.nationality != null ? obj.nationality : "";
    this.address = obj.address != null ? obj.address : "";
    this.phone = obj.phone != null ? obj.phone : "";
    this.academicLevel = obj.academicLevel != null ? obj.academicLevel : "";
    this.specialty = obj.specialty != null ? obj.specialty : "";
    this.currentEmployer =
      obj.currentEmployer != null ? obj.currentEmployer : "";
    this.employerAddress =
      obj.employerAddress != null ? obj.employerAddress : "";
    this.staffId = obj.staffId != null ? obj.staffId : "";
    this.date = obj.date != null ? obj.date : "";
    this.activated = obj.activated != null ? obj.activated : false;
    this.memberId = obj.memberId != null ? obj.memberId : "";
    this.certId = obj.certId != null ? obj.certId : "";
    this.profileImg = obj.profileImg != null ? obj.profileImg : "";
    this.academicProof = obj.academicProof != null ? obj.academicProof : "";
    this.restricted = obj.restricted != null ? obj.restricted : false;
    this.deleted = obj.deleted != null ? obj.deleted : false;
  }
}

export const userConverter = {
  toFirestore: (user) => {
    return {
      firstName: user.firstName,
      lastName: user.lastName,
      otherName: user.otherName,
      gender: user.gender,
      birthDate: user.birthDate,
      email: user.email,
      maritalStatus: user.maritalStatus,
      region: user.region,
      nationality: user.nationality,
      address: user.address,
      phone: user.phone,
      academicLevel: user.academicLevel,
      specialty: user.specialty,
      currentEmployer: user.currentEmployer,
      employerAddress: user.employerAddress,
      staffId: user.staffId,
      date: user.date,
      activated: user.activated,
      memberId: user.memberId,
      certId: user.certId,
      profileImg: user.profileImg,
      academicProof: user.academicProof,
      restricted: user.restricted,
      deleted: user.deleted,
    };
  },
  fromFirestore: (snapshot, options) => {
    const user = snapshot.data(options);
    return new User({
      firstName: user.firstName,
      lastName: user.lastName,
      otherName: user.otherName,
      gender: user.gender,
      birthDate: user.birthDate,
      email: user.email,
      maritalStatus: user.maritalStatus,
      region: user.region,
      nationality: user.nationality,
      address: user.address,
      phone: user.phone,
      academicLevel: user.academicLevel,
      specialty: user.specialty,
      currentEmployer: user.currentEmployer,
      employerAddress: user.employerAddress,
      staffId: user.staffId,
      date: user.date.seconds
        ? new Date(user.date.seconds * 1000).toLocaleDateString()
        : user.date,
      activated: user.activated,
      memberId: user.memberId,
      certId: user.certId,
      profileImg: user.profileImg,
      academicProof: user.academicProof,
      restricted: user.restricted,
      deleted: user.deleted,
    });
  },
};

export class Personal {
  constructor(obj) {
    obj = obj != null ? obj : {};
    this.firstName = obj.firstName != null ? obj.firstName : "";
    this.lastName = obj.lastName != null ? obj.lastName : "";
    this.otherName = obj.otherName != null ? obj.otherName : "";
    this.gender = obj.gender != null ? obj.gender : "";
    this.birthDate = obj.birthDate != null ? obj.birthDate : "";
    this.maritalStatus = obj.maritalStatus != null ? obj.maritalStatus : "";
    this.email = obj.email != null ? obj.email : "";
    this.profileImg = obj.profileImg != null ? obj.profileImg : "";
    this.profileImg = obj.profileImg != null ? obj.profileImg : "";
  }
}

export class Contact {
  constructor(obj) {
    obj = obj != null ? obj : {};
    this.region = obj.region != null ? obj.region : "";
    this.nationality = obj.nationality != null ? obj.nationality : "";
    this.address = obj.address != null ? obj.address : "";
    this.phone = obj.phone != null ? obj.phone : "";
  }
}

export class Work {
  constructor(obj) {
    obj = obj != null ? obj : {};
    this.academicLevel = obj.academicLevel != null ? obj.academicLevel : "";
    this.specialty = obj.specialty != null ? obj.specialty : "";
    this.currentEmployer =
      obj.currentEmployer != null ? obj.currentEmployer : "";
    this.employerAddress =
      obj.employerAddress != null ? obj.employerAddress : "";
    this.staffId = obj.staffId != null ? obj.staffId : "";
    this.academicProof = obj.academicProof != null ? obj.academicProof : "";
  }
}

export class Login {
  constructor(obj) {
    obj = obj != null ? obj : {};
    this.email = obj.email != null ? obj.email : "";
    this.password = obj.password != null ? obj.password : "";
    this.retypePassword = obj.retypePassword != null ? obj.retypePassword : "";
    this.activated = obj.activated != null ? obj.activated : false;
  }
}

export default User;
